import React from "react";

const variants = {
  primary:   "bg-primary text-white hover:bg-primary-dark",
  secondary: "bg-white text-primary border border-primary hover:bg-surface",
  ghost:     "bg-transparent text-brand-muted hover:text-primary",
  danger:    "bg-danger text-white hover:bg-red-600",
  cta:       "bg-cta text-white hover:opacity-90",
  success:   "bg-success text-white hover:bg-green-600",
};

const sizes = {
  sm:  "px-3 py-1.5 text-sm",
  md:  "px-5 py-2.5 text-sm",
  lg:  "px-7 py-3 text-base",
};

const Button = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  ...props
}) => (
  <button
    className={`inline-flex items-center gap-2 rounded-lg font-semibold transition-all duration-200 cursor-pointer disabled:opacity-50 ${variants[variant]} ${sizes[size]} ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;
